// import React, { useState } from "react";
// import useApi from "../../../CustomHooks/useApi";
// import { useSelector } from "react-redux";

// // ─── Icons ───────────────────────────────────────────────────────
// const Icons = {
//     FASTAG: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="2" y="7" width="20" height="10" rx="2" ry="2" />
//             <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
//             <line x1="12" y1="12" x2="12" y2="12.01" strokeWidth="3" />
//             <path d="M8 12h.01M16 12h.01" strokeWidth="2.5" />
//         </svg>
//     ),
//     Search: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//         </svg>
//     ),
//     Check: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="20 6 9 17 4 12" />
//         </svg>
//     ),
//     Lock: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
//             <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//     ),
//     ArrowLeft: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
//         </svg>
//     ),
//     ChevronRight: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="9 18 15 12 9 6" />
//         </svg>
//     ),
//     Receipt: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" />
//             <line x1="8" y1="8" x2="16" y2="8" />
//             <line x1="8" y1="12" x2="16" y2="12" />
//             <line x1="8" y1="16" x2="12" y2="16" />
//         </svg>
//     ),
//     CheckCircle: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//             <polyline points="22 4 12 14.01 9 11.01" />
//         </svg>
//     ),
//     Alert: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//             <line x1="12" y1="9" x2="12" y2="13" />
//             <line x1="12" y1="17" x2="12.01" y2="17" />
//         </svg>
//     ),
// };

// // ─── Config ───────────────────────────────────────────────────────
// const FASTAG_CFG = {
//     label: "FASTag",
//     accent: "#EA580C",
//     light: "#FFF7ED",
//     border: "#FED7AA",
//     dark: "#9A3412",
// };

// // ─── Helpers ──────────────────────────────────────────────────────
// const isFailureResponse = (response) => {
//     if (!response) return true;
//     const res = response?.data ?? response;
//     if (res?.error_code) return true;
//     if (Number(res?.status) === 202) return true;
//     if (typeof res?.status === "string" &&
//         ["FAILED", "FAILURE", "ERROR"].includes(res.status.toUpperCase())) return true;
//     return false;
// };

// const getResponseMessage = (response) => {
//     const res = response?.data ?? response;
//     return res?.message || res?.customerSummary || res?.error || "Transaction completed";
// };

// // ─── Sub-components ───────────────────────────────────────────────
// const Field = ({ label, type = "text", value, onChange, placeholder, maxLength, error, hint }) => {
//     const [focused, setFocused] = useState(false);
//     return (
//         <div>
//             <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
//                 {label}
//             </label>
//             <input
//                 type={type} value={value} onChange={onChange}
//                 placeholder={placeholder} maxLength={maxLength}
//                 onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
//                 style={{
//                     display: "block", width: "100%", height: 44, borderRadius: 10,
//                     border: `1.5px solid ${error ? "#EF4444" : focused ? "#1D4ED8" : "#D1D5DB"}`,
//                     padding: "0 14px", fontSize: 14, color: "#111827",
//                     background: "#fff", outline: "none", fontFamily: "inherit",
//                     boxShadow: focused ? "0 0 0 3px rgba(29,78,216,0.1)" : "none",
//                     transition: "border-color 0.2s, box-shadow 0.2s", boxSizing: "border-box",
//                 }}
//             />
//             {error && <p style={{ marginTop: 5, fontSize: 12, color: "#DC2626" }}>⚠ {error}</p>}
//             {hint && !error && <p style={{ marginTop: 5, fontSize: 12, color: "#9CA3AF" }}>{hint}</p>}
//         </div>
//     );
// };

// const PrimaryButton = ({ onClick, disabled, loading, children, variant = "navy" }) => {
//     const [hovered, setHovered] = useState(false);
//     const bgMap = {
//         navy: { base: "#1E3A5F", hover: "#15294A", disabled: "#E5E7EB" },
//         green: { base: "#059669", hover: "#047857", disabled: "#E5E7EB" },
//         red: { base: "#DC2626", hover: "#B91C1C", disabled: "#E5E7EB" },
//     };
//     const colors = bgMap[variant];
//     const bg = disabled || loading ? colors.disabled : hovered ? colors.hover : colors.base;
//     return (
//         <button
//             onClick={onClick} disabled={disabled || loading}
//             onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
//             style={{
//                 display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
//                 width: "100%", height: 48, borderRadius: 12, border: "none",
//                 background: bg, color: disabled || loading ? "#9CA3AF" : "#fff",
//                 fontWeight: 700, fontSize: 14, letterSpacing: 0.2,
//                 cursor: disabled || loading ? "not-allowed" : "pointer",
//                 fontFamily: "inherit", transition: "background 0.2s",
//                 boxShadow: disabled || loading ? "none" : "0 1px 3px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1)",
//             }}
//         >
//             {loading ? (
//                 <>
//                     <span style={{ width: 16, height: 16, border: "2px solid #D1D5DB", borderTopColor: "transparent", borderRadius: "50%", display: "inline-block", animation: "ft-spin 0.7s linear infinite" }} />
//                     Processing…
//                 </>
//             ) : children}
//         </button>
//     );
// };

// const SectionLabel = ({ children }) => (
//     <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: "uppercase", color: "#9CA3AF", marginBottom: 14 }}>
//         {children}
//     </p>
// );

// const Card = ({ children, style = {} }) => (
//     <div style={{
//         background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
//         boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04)",
//         padding: 20, ...style,
//     }}>
//         {children}
//     </div>
// );

// // ─── Main Component ───────────────────────────────────────────────
// const Fastag = ({ onBack }) => {
//     const { lat, lng } = useSelector((state) => state.location);
//     const mid = useSelector((state) => state.auth.employeeDetails?.username);
//     const merchantAccountNo = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);

//     const { callApi } = useApi("/recharge/services", "GET");
//     const { callApi: fetchBillApi } = useApi("/recharge/fetch-bill", "POST");
//     const { callApi: payBillApi } = useApi("/recharge/pay", "POST");

//     const [operators, setOperators] = useState([]);
//     const [selectedOperator, setSelectedOperator] = useState(null);
//     const [formData, setFormData] = useState({});
//     const [errors, setErrors] = useState({});
//     const [searchTerm, setSearchTerm] = useState("");
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [isFetchingBill, setIsFetchingBill] = useState(false);
//     const [isLoadingOperators, setIsLoadingOperators] = useState(false);
//     const [billDetails, setBillDetails] = useState(null);
//     const [mpin, setMpin] = useState("");
//     const [isPaying, setIsPaying] = useState(false);
//     const [showResponsePopup, setShowResponsePopup] = useState(false);
//     const [paymentResult, setPaymentResult] = useState(null);
//     const [manualAmount, setManualAmount] = useState("");

//     const MANUAL_AMOUNT_TYPES = ["EXACT_AND_BELOW", "EXACT_AND_ABOVE", "ANY"];
//     const allowManualAmount = MANUAL_AMOUNT_TYPES.includes(selectedOperator?.amount_exactness);
//     const filteredOperators = operators.filter((op) =>
//         op.service_name.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // step: 0 = operator, 1 = form, 2 = pay
//     const step = !selectedOperator ? 0 : !billDetails ? 1 : 2;

//     // Fetch operators on mount
//     React.useEffect(() => {
//         const fetchOperators = async () => {
//             setIsLoadingOperators(true);
//             try {
//                 const response = await callApi(null, "?serviceType=FASTAG");
//                 if (response?.Resp_code === "RCS") setOperators(response.data);
//             } catch (err) {
//                 console.error(err);
//             } finally {
//                 setIsLoadingOperators(false);
//             }
//         };
//         fetchOperators();
//     }, []);

//     const handleInputChange = (key, value, regex) => {
//         setFormData((prev) => ({ ...prev, [key]: value }));
//         if (!new RegExp(regex).test(value)) {
//             setErrors((prev) => ({ ...prev, [key]: "Invalid value" }));
//         } else {
//             setErrors((prev) => { const e = { ...prev }; delete e[key]; return e; });
//         }
//     };

//     const handleFetchBill = async () => {
//         if (Object.keys(errors).length > 0) return alert("Fix validation errors first");
//         if (!selectedOperator) return alert("Select an operator");
//         if (!lat || !lng) return alert("Location unavailable");
//         setIsFetchingBill(true);
//         try {
//             const response = await fetchBillApi({
//                 serviceType: "FASTAG",
//                 operator: selectedOperator.service_code,
//                 params: { ...formData, lat, long: lng },
//             });
//             if (response?.status === "SUCCESS") setBillDetails(response.billData);
//             else alert(response?.message || "Failed to fetch bill");
//         } catch (err) {
//             console.error(err);
//         } finally {
//             setIsFetchingBill(false);
//         }
//     };

//     const handlePayBill = async () => {
//         if (!mpin) return alert("Enter MPIN");
//         if (!lat || !lng) return alert("Location unavailable");
//         if (allowManualAmount) {
//             const entered = Number(manualAmount);
//             const billAmount = Number(billDetails?.amount);

//             if (!manualAmount || entered <= 0) {
//                 return alert("Please enter a valid amount.");
//             }

//             if (selectedOperator.amount_exactness === "EXACT_AND_BELOW" && entered > billAmount) {
//                 return alert(`Amount cannot exceed ₹${billAmount}`);
//             }

//             if (selectedOperator.amount_exactness === "EXACT_AND_ABOVE" && entered < billAmount) {
//                 return alert(`Amount must be at least ₹${billAmount}`);
//             }
//         }
//         setIsPaying(true);
//         try {
//             const response = await payBillApi({
//                 mid, mpin, merchantAccountNo,
//                 serviceType: "FASTAG",
//                 operator: selectedOperator.service_code,
//                 amount: allowManualAmount ? Number(manualAmount) : Number(billDetails?.amount),
//                 searchId: billDetails?.searchID,
//                 params: { ...formData, lat, long: lng, opName: selectedOperator.service_name },
//                 billData: {
//                     customer_name: billDetails?.customerName,
//                     bill_id: billDetails?.billId,
//                     bill_date: billDetails?.billDate,
//                     due_date: billDetails?.dueDate,
//                     bill_period: billDetails?.billPeriod,
//                     amount: billDetails?.amount,
//                 },
//             });
//             const failed = isFailureResponse(response);
//             setPaymentResult({
//                 status: failed ? "FAILED" : "SUCCESS",
//                 message: getResponseMessage(response),
//             });
//             setShowResponsePopup(true);
//         } catch (err) {
//             console.error(err);
//             setPaymentResult({
//                 status: "FAILED",
//                 message: err?.response?.data?.message || err.message || "Payment failed. Please try again.",
//             });
//             setShowResponsePopup(true);
//         } finally {
//             setIsPaying(false);
//         }
//     };

//     const fullReset = () => {
//         setPaymentResult(null);
//         setSelectedOperator(null);
//         setBillDetails(null);
//         setFormData({});
//         setErrors({});
//         setSearchTerm("");
//         setMpin("");
//         setManualAmount("");
//         setShowResponsePopup(false);
//     };

//     const isSuccess = paymentResult?.status === "SUCCESS";

//     return (
//         <>
//             <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap');
//         *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
//         .ft-page {
//           min-height: 100vh; background: #F1F5F9;
//           font-family: 'DM Sans', sans-serif;
//           padding: 28px 16px 80px; -webkit-font-smoothing: antialiased;
//         }
//         input, button { font-family: 'DM Sans', sans-serif; }
//         input::placeholder { color: #9CA3AF; font-size: 13px; }
//         .ft-operator-row {
//           display: flex; align-items: center; justify-content: space-between;
//           padding: 11px 14px; cursor: pointer; font-size: 14px; color: #374151;
//           border-bottom: 1px solid #F3F4F6; transition: background 0.15s;
//         }
//         .ft-operator-row:hover { background: #F8FAFF; color: #1D4ED8; }
//         .ft-operator-row:last-child { border-bottom: none; }
//         .ft-bill-row {
//           display: flex; justify-content: space-between; align-items: center;
//           padding: 9px 0; border-bottom: 1px solid #F3F4F6; font-size: 13.5px;
//         }
//         .ft-bill-row:last-child { border-bottom: none; }
//         .ft-tag {
//           display: inline-flex; align-items: center; gap: 4px;
//           padding: 3px 10px; border-radius: 6px; font-size: 11.5px; font-weight: 600;
//         }
//         .ft-step-dot {
//           width: 28px; height: 28px; border-radius: 50%;
//           display: flex; align-items: center; justify-content: center;
//           font-size: 12px; font-weight: 700; transition: all 0.3s ease; flex-shrink: 0;
//         }
//         @keyframes ft-spin { to { transform: rotate(360deg); } }
//         @keyframes ft-fade-up {
//           from { opacity: 0; transform: translateY(8px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes ft-slide-up {
//           from { transform: translateY(100%); opacity: 0; }
//           to   { transform: translateY(0); opacity: 1; }
//         }
//         .ft-fade-up { animation: ft-fade-up 0.28s ease forwards; }
//         @media (max-width: 480px) {
//           .ft-page { padding: 20px 12px 60px; }
//         }
//       `}</style>

//             <div className="ft-page">
//                 <div style={{ maxWidth: 480, margin: "0 auto" }}>

//                     {/* ── Header ── */}
//                     <div style={{ marginBottom: 24 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                             <button
//                                 onClick={onBack}
//                                 style={{
//                                     width: 38, height: 38, borderRadius: 10, border: "1.5px solid #E5E7EB",
//                                     background: "#fff", cursor: "pointer", display: "flex",
//                                     alignItems: "center", justifyContent: "center", color: "#374151",
//                                     flexShrink: 0, transition: "all 0.15s",
//                                 }}
//                                 onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#FED7AA"; e.currentTarget.style.background = "#FFF7ED"; }}
//                                 onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.background = "#fff"; }}
//                             >
//                                 <span style={{ width: 16, height: 16 }}>{Icons.ArrowLeft}</span>
//                             </button>
//                             <div>
//                                 <p style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 500, letterSpacing: 0.3 }}>Bill Payment</p>
//                                 <h2 style={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>FASTag Recharge</h2>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ── Step Indicator ── */}
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: 28 }}>
//                         {["Operator", "Details", "Pay"].map((label, i) => {
//                             const done = step > i;
//                             const active = step === i;
//                             return (
//                                 <React.Fragment key={label}>
//                                     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
//                                         <div className="ft-step-dot" style={{
//                                             background: done ? "#1E3A5F" : active ? "#FFF7ED" : "#F1F5F9",
//                                             border: `2px solid ${done || active ? "#EA580C" : "#D1D5DB"}`,
//                                             color: done ? "#fff" : active ? "#EA580C" : "#9CA3AF",
//                                         }}>
//                                             {done
//                                                 ? <span style={{ width: 12, height: 12 }}>{Icons.Check}</span>
//                                                 : i + 1}
//                                         </div>
//                                         <span style={{
//                                             fontSize: 10, fontWeight: 600, whiteSpace: "nowrap", letterSpacing: 0.2,
//                                             color: active ? "#EA580C" : done ? "#6B7280" : "#9CA3AF",
//                                         }}>
//                                             {label}
//                                         </span>
//                                     </div>
//                                     {i < 2 && (
//                                         <div style={{
//                                             flex: 1, height: 2, margin: "0 4px", marginBottom: 16,
//                                             background: step > i ? "#EA580C" : "#E5E7EB",
//                                             transition: "background 0.3s",
//                                         }} />
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </div>

//                     <div className="ft-fade-up">

//                         {/* ── Operator Search ── */}
//                         {!selectedOperator && (
//                             <Card style={{ marginBottom: 14 }}>
//                                 <SectionLabel>Select Issuer Bank</SectionLabel>
//                                 {isLoadingOperators ? (
//                                     <div style={{ textAlign: "center", padding: "20px 0", color: "#9CA3AF", fontSize: 13 }}>
//                                         <span style={{ width: 18, height: 18, border: "2px solid #E5E7EB", borderTopColor: "#EA580C", borderRadius: "50%", display: "inline-block", animation: "ft-spin 0.7s linear infinite", marginRight: 8 }} />
//                                         Loading banks...
//                                     </div>
//                                 ) : (
//                                     <div style={{ position: "relative" }}>
//                                         <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#9CA3AF", pointerEvents: "none" }}>
//                                             {Icons.Search}
//                                         </span>
//                                         <input
//                                             type="text"
//                                             placeholder="Search issuer bank..."
//                                             value={searchTerm}
//                                             onChange={(e) => { setSearchTerm(e.target.value); setShowDropdown(true); }}
//                                             onFocus={() => setShowDropdown(true)}
//                                             style={{ width: "100%", height: 44, borderRadius: 10, border: "1.5px solid #D1D5DB", paddingLeft: 38, paddingRight: 14, fontSize: 14, color: "#111827", outline: "none", fontFamily: "inherit" }}
//                                         />
//                                         {showDropdown && filteredOperators.length > 0 && (
//                                             <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 50, background: "#fff", borderRadius: 12, border: "1.5px solid #E5E7EB", boxShadow: "0 8px 30px rgba(0,0,0,0.1)", maxHeight: 220, overflowY: "auto" }}>
//                                                 {filteredOperators.map((op) => (
//                                                     <div
//                                                         key={op.service_id}
//                                                         className="ft-operator-row"
//                                                         onClick={() => { setSelectedOperator(op); setSearchTerm(op.service_name); setShowDropdown(false); setFormData({}); setErrors({}); }}
//                                                     >
//                                                         <span>{op.service_name}</span>
//                                                         <span style={{ width: 14, height: 14, color: "#D1D5DB" }}>{Icons.ChevronRight}</span>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </Card>
//                         )}

//                         {/* ── Selected Operator Pill ── */}
//                         {selectedOperator && !billDetails && (
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#FFF7ED", border: "1.5px solid #FED7AA", borderRadius: 12, padding: "10px 14px", marginBottom: 14 }}>
//                                 <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                                     <div style={{ width: 34, height: 34, borderRadius: 8, background: FASTAG_CFG.light, color: FASTAG_CFG.accent, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                         <span style={{ width: 16, height: 16 }}>{Icons.FASTAG}</span>
//                                     </div>
//                                     <div>
//                                         <p style={{ fontSize: 11, color: "#6B7280", marginBottom: 1 }}>Issuer Bank</p>
//                                         <p style={{ fontSize: 14, fontWeight: 600, color: "#9A3412" }}>{selectedOperator.service_name}</p>
//                                     </div>
//                                 </div>
//                                 <button
//                                     onClick={() => { setSelectedOperator(null); setSearchTerm(""); setFormData({}); setErrors({}); setBillDetails(null); }}
//                                     style={{ fontSize: 12, fontWeight: 600, color: "#EA580C", background: "none", border: "none", cursor: "pointer", padding: "4px 0" }}
//                                 >
//                                     Change
//                                 </button>
//                             </div>
//                         )}

//                         {/* ── Params Form ── */}
//                         {selectedOperator && !billDetails && (
//                             <Card style={{ marginBottom: 14 }}>
//                                 <SectionLabel>Vehicle Details</SectionLabel>
//                                 <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
//                                     {Object.entries(selectedOperator.params).map(([key, param]) => (
//                                         <Field
//                                             key={key}
//                                             label={param.param_name}
//                                             type={param.param_type}
//                                             error={errors[key]}
//                                             onChange={(e) => handleInputChange(key, e.target.value, param.full_regex)}
//                                         />
//                                     ))}
//                                 </div>
//                                 <div style={{ marginTop: 20 }}>
//                                     <PrimaryButton onClick={handleFetchBill} loading={isFetchingBill}>
//                                         <span style={{ width: 16, height: 16 }}>{Icons.Receipt}</span>
//                                         Fetch Tag Details
//                                     </PrimaryButton>
//                                 </div>
//                             </Card>
//                         )}

//                         {/* ── Bill Details ── */}
//                         {billDetails && (
//                             <div>
//                                 <Card style={{ marginBottom: 14, padding: 0, overflow: "hidden" }}>
//                                     <div style={{ background: "linear-gradient(135deg, #431407 0%, #9A3412 100%)", padding: "20px 20px 22px" }}>
//                                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                                             <div>
//                                                 <p style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", letterSpacing: 0.8, marginBottom: 6, textTransform: "uppercase" }}>Amount Due</p>
//                                                 <p style={{ fontSize: 32, fontWeight: 700, color: "#fff", fontFamily: "'DM Mono', monospace", letterSpacing: -0.5 }}>
//                                                     ₹{billDetails.amount || "—"}
//                                                 </p>
//                                             </div>
//                                             <div style={{ textAlign: "right" }}>
//                                                 <p style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", marginBottom: 4 }}>Due Date</p>
//                                                 <p style={{ fontSize: 14, fontWeight: 600, color: "#FCD34D" }}>{billDetails.dueDate || "—"}</p>
//                                                 <div style={{ marginTop: 8 }}>
//                                                     <span className="ft-tag" style={{ background: FASTAG_CFG.light, color: FASTAG_CFG.dark }}>
//                                                         <span style={{ width: 12, height: 12 }}>{Icons.FASTAG}</span>
//                                                         FASTag
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div style={{ padding: "16px 20px" }}>
//                                         <SectionLabel>Tag Summary</SectionLabel>
//                                         {[
//                                             { label: "Vehicle Owner", value: billDetails.customerName },
//                                             { label: "Tag / Bill ID", value: billDetails.billId },
//                                             { label: "Bill Date", value: billDetails.billDate },
//                                             { label: "Billing Period", value: billDetails.billPeriod },
//                                             { label: "Issuer Bank", value: selectedOperator.service_name },
//                                         ].filter((r) => r.value).map(({ label, value }) => (
//                                             <div key={label} className="ft-bill-row">
//                                                 <span style={{ color: "#6B7280" }}>{label}</span>
//                                                 <span style={{ fontWeight: 500, color: "#111827" }}>{value}</span>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </Card>

//                                 {/* ── Auth Card ── */}
//                                 <Card>
//                                     <SectionLabel>Authorize Payment</SectionLabel>
//                                     <div style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#FFF7ED", border: "1px solid #FED7AA", borderRadius: 10, padding: "11px 14px", marginBottom: 16 }}>
//                                         <span style={{ width: 16, height: 16, color: "#EA580C", marginTop: 1, flexShrink: 0 }}>{Icons.Alert}</span>
//                                         <p style={{ fontSize: 12.5, color: "#9A3412", lineHeight: 1.55 }}>
//                                             You are authorizing FASTag recharge of{" "}
//                                             <strong style={{ fontFamily: "'DM Mono', monospace" }}>₹{billDetails.amount}</strong>{" "}
//                                             via {selectedOperator.service_name}.
//                                         </p>
//                                     </div>
//                                     {allowManualAmount && (
//                                         <div style={{ marginBottom: 16 }}>
//                                             <Field
//                                                 label="Enter Amount"
//                                                 type="number"
//                                                 value={manualAmount}
//                                                 onChange={(e) => setManualAmount(e.target.value)}
//                                                 placeholder="Enter recharge amount"
//                                                 hint={
//                                                     selectedOperator.amount_exactness === "EXACT_AND_BELOW"
//                                                         ? `Enter up to ₹${billDetails?.amount}`
//                                                         : selectedOperator.amount_exactness === "EXACT_AND_ABOVE"
//                                                             ? `Minimum ₹${billDetails?.amount}`
//                                                             : "Enter any amount"
//                                                 }
//                                             />
//                                         </div>
//                                     )}
//                                     <Field
//                                         label="6-Digit MPIN" type="password" maxLength={6}
//                                         value={mpin} onChange={(e) => setMpin(e.target.value)}
//                                         placeholder="● ● ● ● ● ●" hint="Your MPIN is encrypted and never stored"
//                                     />
//                                     <div style={{ marginTop: 16 }}>
//                                         <PrimaryButton onClick={handlePayBill} loading={isPaying}>
//                                             <span style={{ width: 16, height: 16 }}>{Icons.Lock}</span>
//                                             Recharge ₹{allowManualAmount ? (manualAmount || "—") : billDetails.amount} Securely
//                                         </PrimaryButton>
//                                     </div>
//                                     <div style={{ marginTop: 12, display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}>
//                                         <span style={{ width: 12, height: 12, color: "#10B981" }}>{Icons.Lock}</span>
//                                         <span style={{ fontSize: 11, color: "#9CA3AF" }}>256-bit SSL encrypted · PCI DSS compliant</span>
//                                     </div>
//                                 </Card>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* ── Result Bottom Sheet ── */}
//             {showResponsePopup && paymentResult && (
//                 <div
//                     style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", display: "flex", alignItems: "flex-end", justifyContent: "center" }}
//                     onClick={(e) => { if (e.target === e.currentTarget) { setShowResponsePopup(false); if (isSuccess) onBack(); else fullReset(); } }}
//                 >
//                     <div style={{
//                         width: "100%", maxWidth: 480, background: "#fff",
//                         borderRadius: "20px 20px 0 0",
//                         boxShadow: "0 -4px 40px rgba(0,0,0,0.12)",
//                         animation: "ft-slide-up 0.32s cubic-bezier(0.32,0.72,0,1) forwards",
//                         paddingBottom: 40,
//                     }}>
//                         <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 0" }}>
//                             <div style={{ width: 32, height: 4, borderRadius: 2, background: "#E5E7EB" }} />
//                         </div>
//                         <div style={{ padding: "24px 28px 0", textAlign: "center" }}>
//                             <div style={{
//                                 width: 60, height: 60, borderRadius: "50%",
//                                 background: isSuccess ? "#ECFDF5" : "#FEF2F2",
//                                 border: `2px solid ${isSuccess ? "#6EE7B7" : "#FCA5A5"}`,
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 margin: "0 auto 18px",
//                                 color: isSuccess ? "#059669" : "#DC2626",
//                             }}>
//                                 <span style={{ width: 28, height: 28 }}>
//                                     {isSuccess ? Icons.CheckCircle : Icons.Alert}
//                                 </span>
//                             </div>
//                             <p style={{ fontSize: 14, color: "#6B7280", lineHeight: 1.6, marginBottom: 24 }}>
//                                 {paymentResult.message}
//                             </p>
//                             <div style={{
//                                 display: "flex", justifyContent: "space-between",
//                                 background: "#F8FAFC", borderRadius: 12, padding: "14px 18px",
//                                 marginBottom: 20, border: "1px solid #E5E7EB",
//                             }}>
//                                 <div style={{ textAlign: "left" }}>
//                                     <p style={{ fontSize: 11, color: "#9CA3AF", marginBottom: 2 }}>Service</p>
//                                     <p style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>FASTag</p>
//                                 </div>
//                                 <div style={{ textAlign: "right" }}>
//                                     <p style={{ fontSize: 11, color: "#9CA3AF", marginBottom: 2 }}>
//                                         {isSuccess ? "Amount Recharged" : "Attempted Amount"}
//                                     </p>
//                                     <p style={{
//                                         fontSize: 14, fontWeight: 700,
//                                         color: isSuccess ? "#059669" : "#DC2626",
//                                         fontFamily: "'DM Mono', monospace",
//                                     }}>
//                                         ₹{allowManualAmount ? manualAmount : billDetails?.amount}
//                                     </p>
//                                 </div>
//                             </div>
//                             <PrimaryButton
//                                 variant={isSuccess ? "green" : "red"}
//                                 onClick={() => { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); }}
//                             >
//                                 {isSuccess ? "Done" : "Try Again"}
//                             </PrimaryButton>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Fastag;




// import React, { useState } from "react";
// import useApi from "../../../CustomHooks/useApi";
// import { useSelector } from "react-redux";

// // ─── Icons ───────────────────────────────────────────────────────
// const Icons = {
//     FASTAG: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="2" y="7" width="20" height="10" rx="2" ry="2" />
//             <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
//             <line x1="12" y1="12" x2="12" y2="12.01" strokeWidth="3" />
//             <path d="M8 12h.01M16 12h.01" strokeWidth="2.5" />
//         </svg>
//     ),
//     Search: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//         </svg>
//     ),
//     Check: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="20 6 9 17 4 12" />
//         </svg>
//     ),
//     Lock: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
//             <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//     ),
//     ArrowLeft: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
//         </svg>
//     ),
//     ChevronRight: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <polyline points="9 18 15 12 9 6" />
//         </svg>
//     ),
//     Receipt: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" />
//             <line x1="8" y1="8" x2="16" y2="8" />
//             <line x1="8" y1="12" x2="16" y2="12" />
//             <line x1="8" y1="16" x2="12" y2="16" />
//         </svg>
//     ),
//     CheckCircle: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//             <polyline points="22 4 12 14.01 9 11.01" />
//         </svg>
//     ),
//     Alert: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//             <line x1="12" y1="9" x2="12" y2="13" />
//             <line x1="12" y1="17" x2="12.01" y2="17" />
//         </svg>
//     ),
// };

// // ─── Config ───────────────────────────────────────────────────────
// const FASTAG_CFG = {
//     label: "FASTag",
//     accent: "#EA580C",
//     light: "#FFF7ED",
//     border: "#FED7AA",
//     dark: "#9A3412",
// };

// // ─── Helpers ──────────────────────────────────────────────────────
// const isFailureResponse = (response) => {
//     if (!response) return true;
//     const res = response?.data ?? response;
//     if (res?.error_code) return true;
//     if (Number(res?.status) === 202) return true;
//     if (typeof res?.status === "string" &&
//         ["FAILED", "FAILURE", "ERROR"].includes(res.status.toUpperCase())) return true;
//     return false;
// };

// const getResponseMessage = (response) => {
//     const res = response?.data ?? response;
//     return res?.message || res?.customerSummary || res?.error || "Transaction completed";
// };

// // ─── Sub-components ───────────────────────────────────────────────
// const Field = ({ label, type = "text", value, onChange, placeholder, maxLength, error, hint }) => {
//     const [focused, setFocused] = useState(false);
//     return (
//         <div>
//             <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
//                 {label}
//             </label>
//             <input
//                 type={type} value={value} onChange={onChange}
//                 placeholder={placeholder} maxLength={maxLength}
//                 onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
//                 style={{
//                     display: "block", width: "100%", height: 44, borderRadius: 10,
//                     border: `1.5px solid ${error ? "#EF4444" : focused ? "#1D4ED8" : "#D1D5DB"}`,
//                     padding: "0 14px", fontSize: 14, color: "#111827",
//                     background: "#fff", outline: "none", fontFamily: "inherit",
//                     boxShadow: focused ? "0 0 0 3px rgba(29,78,216,0.1)" : "none",
//                     transition: "border-color 0.2s, box-shadow 0.2s", boxSizing: "border-box",
//                 }}
//             />
//             {error && <p style={{ marginTop: 5, fontSize: 12, color: "#DC2626" }}>⚠ {error}</p>}
//             {hint && !error && <p style={{ marginTop: 5, fontSize: 12, color: "#9CA3AF" }}>{hint}</p>}
//         </div>
//     );
// };

// const PrimaryButton = ({ onClick, disabled, loading, children, variant = "navy" }) => {
//     const [hovered, setHovered] = useState(false);
//     const bgMap = {
//         navy: { base: "#1E3A5F", hover: "#15294A", disabled: "#E5E7EB" },
//         green: { base: "#059669", hover: "#047857", disabled: "#E5E7EB" },
//         red: { base: "#DC2626", hover: "#B91C1C", disabled: "#E5E7EB" },
//     };
//     const colors = bgMap[variant];
//     const bg = disabled || loading ? colors.disabled : hovered ? colors.hover : colors.base;
//     return (
//         <button
//             onClick={onClick} disabled={disabled || loading}
//             onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
//             style={{
//                 display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
//                 width: "100%", height: 48, borderRadius: 12, border: "none",
//                 background: bg, color: disabled || loading ? "#9CA3AF" : "#fff",
//                 fontWeight: 700, fontSize: 14, letterSpacing: 0.2,
//                 cursor: disabled || loading ? "not-allowed" : "pointer",
//                 fontFamily: "inherit", transition: "background 0.2s",
//                 boxShadow: disabled || loading ? "none" : "0 1px 3px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1)",
//             }}
//         >
//             {loading ? (
//                 <>
//                     <span style={{ width: 16, height: 16, border: "2px solid #D1D5DB", borderTopColor: "transparent", borderRadius: "50%", display: "inline-block", animation: "ft-spin 0.7s linear infinite" }} />
//                     Processing…
//                 </>
//             ) : children}
//         </button>
//     );
// };

// const SectionLabel = ({ children }) => (
//     <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: "uppercase", color: "#9CA3AF", marginBottom: 14 }}>
//         {children}
//     </p>
// );

// const Card = ({ children, style = {} }) => (
//     <div style={{
//         background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
//         boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04)",
//         padding: 20, ...style,
//     }}>
//         {children}
//     </div>
// );

// // ─── Main Component ───────────────────────────────────────────────
// const Fastag = ({ onBack }) => {
//     const mid = useSelector((state) => state.auth.employeeDetails?.username) || "mer2347_7867";
//     const merchantAccountNo = useSelector((state) => state.auth.employeeDetails?.merchant_account_no) || "ACC123456";

//     // Hooks matching your base URLs
//     const { callApi: fetchBillApi } = useApi("/recharge/fastag-info", "POST");
//     const { callApi: payBillApi } = useApi("/recharge/transaction/fastag", "POST");

//     const [operators, setOperators] = useState([]);
//     const [selectedOperator, setSelectedOperator] = useState(null);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [isFetchingBill, setIsFetchingBill] = useState(false);
    
//     // Form Inputs
//     const [vehicleNumber, setVehicleNumber] = useState("");
//     const [mobileNumber, setMobileNumber] = useState("");
//     const [mpin, setMpin] = useState("");
//     const [manualAmount, setManualAmount] = useState("");

//     // Field Error Triggers
//     const [formErrors, setFormErrors] = useState({});
    
//     // Server Response States
//     const [billDetails, setBillDetails] = useState(null);
//     const [isPaying, setIsPaying] = useState(false);
//     const [showResponsePopup, setShowResponsePopup] = useState(false);
//     const [paymentResult, setPaymentResult] = useState(null);

//     const FASTAG_OPERATORS = [
//         { service_id: 195, service_name: "Indian Highways Management Company Ltd-Indusind FASTag" },
//         { service_id: 196, service_name: "IndusInd Bank" },
//         { service_id: 197, service_name: "Bank Of Baroda" },
//         { service_id: 198, service_name: "ICICI Bank" },
//         { service_id: 199, service_name: "HDFC Bank" },
//         { service_id: 200, service_name: "Airtel Payments Bank NETC FASTag" },
//         { service_id: 201, service_name: "IDFC FIRST Bank - FasTag" },
//         { service_id: 202, service_name: "Axis Bank" },
//         { service_id: 203, service_name: "Kotak Mahindra Bank" },
//         { service_id: 204, service_name: "Equitas FASTag Recharge" },
//         { service_id: 205, service_name: "Paul Merchants" },
//         { service_id: 206, service_name: "Jammu and Kashmir Bank Fastag" },
//         { service_id: 207, service_name: "Federal Bank - FASTag" },
//         { service_id: 208, service_name: "IDBI Bank FASTag" },
//         { service_id: 209, service_name: "UCO Bank FASTag" },
//         { service_id: 210, service_name: "Transaction Analyst FASTag" },
//         { service_id: 211, service_name: "IOB FASTag" },
//         { service_id: 212, service_name: "State Bank of India FASTag" },
//         { service_id: 213, service_name: "Transcorp International Limited" },
//         { service_id: 214, service_name: "Karnataka Bank Fastag" },
//         { service_id: 215, service_name: "Bank of Maharashtra FASTag" },
//         { service_id: 216, service_name: "South Indian Bank Fastag" },
//         { service_id: 217, service_name: "Saraswat Bank - FASTag" },
//         { service_id: 218, service_name: "Indian Bank Fastag" },
//         { service_id: 219, service_name: "Livquik Technology India Private Limited" },
//         { service_id: 220, service_name: "Union Bank of India FASTag" },
//         { service_id: 221, service_name: "Canara Bank Fastag" },
//         { service_id: 222, service_name: "AU Bank Fastag" },
//         { service_id: 223, service_name: "Bandhan Bank Fastag" },
//         { service_id: 224, service_name: "Bajaj Finance Limited Fastag" },
//         { service_id: 225, service_name: "Yes Bank FASTag" }
//     ];

//     const MANUAL_AMOUNT_TYPES = ["EXACT_AND_BELOW", "EXACT_AND_ABOVE", "ANY"];
//     const allowManualAmount = MANUAL_AMOUNT_TYPES.includes(selectedOperator?.amount_exactness);
    
//     const filteredOperators = operators.filter((op) =>
//         op.service_name.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // Step Logic: 0 = Choose Issuer, 1 = Input Info, 2 = Pay Summary
//     const step = !selectedOperator ? 0 : !billDetails ? 1 : 2;

//     React.useEffect(() => {
//         setOperators(FASTAG_OPERATORS);
//     }, []);

//     const validateForm = () => {
//         let errors = {};
//         if (!vehicleNumber.trim()) {
//             errors.vehicleNumber = "Vehicle number is required";
//         } else if (!/^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/i.test(vehicleNumber.replace(/\s+/g, ""))) {
//             errors.vehicleNumber = "Invalid format (e.g. MH12AB1234)";
//         }

//         if (!mobileNumber.trim()) {
//             errors.mobileNumber = "Mobile number is required";
//         } else if (!/^\d{10}$/.test(mobileNumber)) {
//             errors.mobileNumber = "Must be a valid 10-digit number";
//         }

//         setFormErrors(errors);
//         return Object.keys(errors).length === 0;
//     };

//     const handleFetchBill = async () => {
//         if (!selectedOperator) return alert("Select an operator bank");
//         if (!validateForm()) return;

//         setIsFetchingBill(true);
//         try {
//             // Using service_id dynamically from the select choice as configured
//             const response = await fetchBillApi({
//                 vehicleNumber: vehicleNumber.toUpperCase().replace(/\s+/g, ""),
//                 operator: selectedOperator.service_id.toString(),
//                 addParams: {}
//             });

//             // Handling target success shape 
//             if (response && (Number(response.status) === 1 || response.status === "SUCCESS")) {
//                 const nestedData = response.rdata?.[0] || {};
//                 setBillDetails({
//                     customerName: nestedData.CustomerName || "Customer Name",
//                     amount: nestedData.Billamount || "0.00",
//                     billDate: nestedData.Billdate || "",
//                     dueDate: nestedData.Duedate || response.dueDate || "",
//                     billValidationId: response.billValidationId || ""
//                 });
//             } else {
//                 alert(response?.message || "Failed to fetch FasTag details");
//             }
//         } catch (err) {
//             console.error(err);
//             alert(err?.response?.data?.message || "Something went wrong fetching outstanding balance.");
//         } finally {
//             setIsFetchingBill(false);
//         }
//     };

//     const handlePayBill = async () => {
//         if (!mpin) return alert("Enter your MPIN");

//         let finalAmount = Number(billDetails?.amount);
//         if (allowManualAmount && manualAmount) {
//             finalAmount = Number(manualAmount);
//         }

//         setIsPaying(true);
//         try {
//             const response = await payBillApi({
//                 optr: selectedOperator.service_id.toString(),
//                 type: "FASTAG",
//                 vehicleNumber: vehicleNumber.toUpperCase().replace(/\s+/g, ""),
//                 bill_amount: finalAmount,
//                 mobile: mobileNumber,
//                 consumerName: billDetails?.customerName || "",
//                 dueDate: billDetails?.dueDate || "",
//                 billValidationId: billDetails?.billValidationId || "",
//                 mid: mid,
//                 txn_amount: finalAmount,
//                 net_amount: finalAmount,
//                 merchant_account_no: merchantAccountNo,
//                 add_params: {},
//                 mpin: mpin
//             });

//             const failed = isFailureResponse(response);
//             setPaymentResult({
//                 status: failed ? "FAILED" : response?.status || "SUCCESS",
//                 message: getResponseMessage(response),
//             });
//             setShowResponsePopup(true);
//         } catch (err) {
//             console.error(err);
//             setPaymentResult({
//                 status: "FAILED",
//                 message: err?.response?.data?.message || err.message || "Payment processing failed.",
//             });
//             setShowResponsePopup(true);
//         } finally {
//             setIsPaying(false);
//         }
//     };

//     const fullReset = () => {
//         setPaymentResult(null);
//         setSelectedOperator(null);
//         setBillDetails(null);
//         setSearchTerm("");
//         setMpin("");
//         setVehicleNumber("");
//         setMobileNumber("");
//         setManualAmount("");
//         setFormErrors({});
//         setShowResponsePopup(false);
//     };

//     const isSuccess = paymentResult?.status === "SUCCESS";

//     return (
//         <>
//             <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap');
//         *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
//         .ft-page {
//           min-height: 100vh; background: #F1F5F9;
//           font-family: 'DM Sans', sans-serif;
//           padding: 28px 16px 80px; -webkit-font-smoothing: antialiased;
//         }
//         input, button { font-family: 'DM Sans', sans-serif; }
//         input::placeholder { color: #9CA3AF; font-size: 13px; }
//         .ft-operator-row {
//           display: flex; align-items: center; justify-content: space-between;
//           padding: 11px 14px; cursor: pointer; font-size: 14px; color: #374151;
//           border-bottom: 1px solid #F3F4F6; transition: background 0.15s;
//         }
//         .ft-operator-row:hover { background: #F8FAFF; color: #1D4ED8; }
//         .ft-operator-row:last-child { border-bottom: none; }
//         .ft-bill-row {
//           display: flex; justify-content: space-between; align-items: center;
//           padding: 9px 0; border-bottom: 1px solid #F3F4F6; font-size: 13.5px;
//         }
//         .ft-bill-row:last-child { border-bottom: none; }
//         .ft-tag {
//           display: inline-flex; align-items: center; gap: 4px;
//           padding: 3px 10px; border-radius: 6px; font-size: 11.5px; font-weight: 600;
//         }
//         .ft-step-dot {
//           width: 28px; height: 28px; border-radius: 50%;
//           display: flex; align-items: center; justify-content: center;
//           font-size: 12px; font-weight: 700; transition: all 0.3s ease; flex-shrink: 0;
//         }
//         @keyframes ft-spin { to { transform: rotate(360deg); } }
//         @keyframes ft-fade-up {
//           from { opacity: 0; transform: translateY(8px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes ft-slide-up {
//           from { transform: translateY(100%); opacity: 0; }
//           to   { transform: translateY(0); opacity: 1; }
//         }
//         .ft-fade-up { animation: ft-fade-up 0.28s ease forwards; }
//         @media (max-width: 480px) {
//           .ft-page { padding: 20px 12px 60px; }
//         }
//       `}</style>

//             <div className="ft-page">
//                 <div style={{ maxWidth: 480, margin: "0 auto" }}>

//                     {/* ── Header ── */}
//                     <div style={{ marginBottom: 24 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                             <button
//                                 onClick={onBack}
//                                 style={{
//                                     width: 38, height: 38, borderRadius: 10, border: "1.5px solid #E5E7EB",
//                                     background: "#fff", cursor: "pointer", display: "flex",
//                                     alignItems: "center", justifyContent: "center", color: "#374151",
//                                     flexShrink: 0, transition: "all 0.15s",
//                                 }}
//                             >
//                                 <span style={{ width: 16, height: 16 }}>{Icons.ArrowLeft}</span>
//                             </button>
//                             <div>
//                                 <p style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 500, letterSpacing: 0.3 }}>Bill Payment</p>
//                                 <h2 style={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>FASTag Recharge</h2>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ── Step Indicator ── */}
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: 28 }}>
//                         {["Operator", "Details", "Pay"].map((label, i) => {
//                             const done = step > i;
//                             const active = step === i;
//                             return (
//                                 <React.Fragment key={label}>
//                                     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
//                                         <div className="ft-step-dot" style={{
//                                             background: done ? "#1E3A5F" : active ? "#FFF7ED" : "#F1F5F9",
//                                             border: `2px solid ${done || active ? "#EA580C" : "#D1D5DB"}`,
//                                             color: done ? "#fff" : active ? "#EA580C" : "#9CA3AF",
//                                         }}>
//                                             {done ? <span style={{ width: 12, height: 12 }}>{Icons.Check}</span> : i + 1}
//                                         </div>
//                                         <span style={{
//                                             fontSize: 10, fontWeight: 600, whiteSpace: "nowrap", letterSpacing: 0.2,
//                                             color: active ? "#EA580C" : done ? "#6B7280" : "#9CA3AF",
//                                         }}>
//                                             {label}
//                                         </span>
//                                     </div>
//                                     {i < 2 && (
//                                         <div style={{
//                                             flex: 1, height: 2, margin: "0 4px", marginBottom: 16,
//                                             background: step > i ? "#EA580C" : "#E5E7EB",
//                                             transition: "background 0.3s",
//                                         }} />
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </div>

//                     <div className="ft-fade-up">

//                         {/* ── Operator Dropdown Base Page ── */}
//                         {!selectedOperator && (
//                             <Card style={{ marginBottom: 14 }}>
//                                 <SectionLabel>Select Issuer Bank</SectionLabel>
//                                 <div style={{ position: "relative" }}>
//                                     <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#9CA3AF", pointerEvents: "none" }}>
//                                         {Icons.Search}
//                                     </span>
//                                     <input
//                                         type="text"
//                                         placeholder="Search FasTag issuing bank..."
//                                         value={searchTerm}
//                                         onChange={(e) => { setSearchTerm(e.target.value); setShowDropdown(true); }}
//                                         onFocus={() => setShowDropdown(true)}
//                                         style={{ width: "100%", height: 44, borderRadius: 10, border: "1.5px solid #D1D5DB", paddingLeft: 38, paddingRight: 14, fontSize: 14, color: "#111827", outline: "none" }}
//                                     />
//                                     {showDropdown && filteredOperators.length > 0 && (
//                                         <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 50, background: "#fff", borderRadius: 12, border: "1.5px solid #E5E7EB", boxShadow: "0 8px 30px rgba(0,0,0,0.1)", maxHeight: 220, overflowY: "auto" }}>
//                                             {filteredOperators.map((op) => (
//                                                 <div
//                                                     key={op.service_id}
//                                                     className="ft-operator-row"
//                                                     onClick={() => { 
//                                                         setSelectedOperator(op); 
//                                                         setSearchTerm(op.service_name); 
//                                                         setShowDropdown(false); 
//                                                     }}
//                                                 >
//                                                     <div>
//                                                         <span style={{ fontWeight: 600, color: "#EA580C", marginRight: 8, fontSize: 12 }}>[{op.service_id}]</span>
//                                                         <span>{op.service_name}</span>
//                                                     </div>
//                                                     <span style={{ width: 14, height: 14, color: "#D1D5DB" }}>{Icons.ChevronRight}</span>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>
//                             </Card>
//                         )}

//                         {/* ── Selected Operator Banner Pill ── */}
//                         {selectedOperator && !billDetails && (
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#FFF7ED", border: "1.5px solid #FED7AA", borderRadius: 12, padding: "10px 14px", marginBottom: 14 }}>
//                                 <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                                     <div style={{ width: 34, height: 34, borderRadius: 8, background: FASTAG_CFG.light, color: FASTAG_CFG.accent, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                         <span style={{ width: 16, height: 16 }}>{Icons.FASTAG}</span>
//                                     </div>
//                                     <div>
//                                         <p style={{ fontSize: 11, color: "#6B7280", marginBottom: 1 }}>Selected Bank Code: {selectedOperator.service_id}</p>
//                                         <p style={{ fontSize: 14, fontWeight: 600, color: "#9A3412" }}>{selectedOperator.service_name}</p>
//                                     </div>
//                                 </div>
//                                 <button
//                                     onClick={() => { setSelectedOperator(null); setBillDetails(null); }}
//                                     style={{ fontSize: 12, fontWeight: 600, color: "#EA580C", background: "none", border: "none", cursor: "pointer" }}
//                                 >
//                                     Change
//                                 </button>
//                             </div>
//                         )}

//                         {/* ── Inputs Page ── */}
//                         {selectedOperator && !billDetails && (
//                             <Card style={{ marginBottom: 14 }}>
//                                 <SectionLabel>Vehicle Identification</SectionLabel>
//                                 <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
//                                     <Field
//                                         label="Vehicle Number"
//                                         type="text"
//                                         value={vehicleNumber}
//                                         onChange={(e) => setVehicleNumber(e.target.value)}
//                                         placeholder="e.g. MH12AB1234"
//                                         error={formErrors.vehicleNumber}
//                                     />
//                                     <Field
//                                         label="Registered Mobile Number"
//                                         type="tel"
//                                         maxLength={10}
//                                         value={mobileNumber}
//                                         onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ""))}
//                                         placeholder="Enter 10-digit mobile number"
//                                         error={formErrors.mobileNumber}
//                                     />
//                                 </div>
//                                 <div style={{ marginTop: 20 }}>
//                                     <PrimaryButton onClick={handleFetchBill} loading={isFetchingBill}>
//                                         <span style={{ width: 16, height: 16 }}>{Icons.Receipt}</span>
//                                         Fetch Outstanding Balance
//                                     </PrimaryButton>
//                                 </div>
//                             </Card>
//                         )}

//                         {/* ── Bill Info & Payment Screen ── */}
//                         {billDetails && (
//                             <div>
//                                 <Card style={{ marginBottom: 14, padding: 0, overflow: "hidden" }}>
//                                     <div style={{ background: "linear-gradient(135deg, #431407 0%, #9A3412 100%)", padding: "20px 20px 22px" }}>
//                                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                                             <div>
//                                                 <p style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", letterSpacing: 0.8, marginBottom: 6, textTransform: "uppercase" }}>Outstanding Balance</p>
//                                                 <p style={{ fontSize: 32, fontWeight: 700, color: "#fff", fontFamily: "'DM Mono', monospace" }}>
//                                                     ₹{billDetails.amount}
//                                                 </p>
//                                             </div>
//                                             <div style={{ textAlign: "right" }}>
//                                                 <p style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", marginBottom: 4 }}>Due Date</p>
//                                                 <p style={{ fontSize: 14, fontWeight: 600, color: "#FCD34D" }}>{billDetails.dueDate || "N/A"}</p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div style={{ padding: "16px 20px" }}>
//                                         <SectionLabel>Statement Summary</SectionLabel>
//                                         {[
//                                             { label: "Customer Name", value: billDetails.customerName },
//                                             { label: "Vehicle Number", value: vehicleNumber.toUpperCase() },
//                                             { label: "Validation ID", value: billDetails.billValidationId },
//                                             { label: "Bill Date", value: billDetails.billDate || "N/A" },
//                                             { label: "Issuer Bank", value: selectedOperator.service_name },
//                                         ].map(({ label, value }) => (
//                                             <div key={label} className="ft-bill-row">
//                                                 <span style={{ color: "#6B7280" }}>{label}</span>
//                                                 <span style={{ fontWeight: 500, color: "#111827" }}>{value}</span>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </Card>

//                                 <Card>
//                                     <SectionLabel>Complete Transaction</SectionLabel>
//                                     {allowManualAmount && (
//                                         <div style={{ marginBottom: 16 }}>
//                                             <Field
//                                                 label="Custom Recharge Amount"
//                                                 type="number"
//                                                 value={manualAmount}
//                                                 onChange={(e) => setManualAmount(e.target.value)}
//                                                 placeholder="Enter amount"
//                                             />
//                                         </div>
//                                     )}
//                                     <Field
//                                         label="6-Digit Security MPIN" type="password" maxLength={6}
//                                         value={mpin} onChange={(e) => setMpin(e.target.value.replace(/\D/g, ""))}
//                                         placeholder="● ● ● ● ● ●"
//                                     />
//                                     <div style={{ marginTop: 16 }}>
//                                         <PrimaryButton onClick={handlePayBill} loading={isPaying}>
//                                             <span style={{ width: 16, height: 16 }}>{Icons.Lock}</span>
//                                             Pay ₹{allowManualAmount ? (manualAmount || billDetails.amount) : billDetails.amount} Now
//                                         </PrimaryButton>
//                                     </div>
//                                 </Card>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* ── Transaction Status Modal ── */}
//             {showResponsePopup && paymentResult && (
//                 <div
//                     style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", display: "flex", alignItems: "flex-end", justifyContent: "center" }}
//                     onClick={() => { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); }}
//                 >
//                     <div style={{ width: "100%", maxWidth: 480, background: "#fff", borderRadius: "20px 20px 0 0", paddingBottom: 40 }} onClick={e => e.stopPropagation()}>
//                         <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 0" }}>
//                             <div style={{ width: 32, height: 4, borderRadius: 2, background: "#E5E7EB" }} />
//                         </div>
//                         <div style={{ padding: "24px 28px 0", textAlign: "center" }}>
//                             <div style={{
//                                 width: 60, height: 60, borderRadius: "50%",
//                                 background: isSuccess ? "#ECFDF5" : "#FEF2F2",
//                                 border: `2px solid ${isSuccess ? "#6EE7B7" : "#FCA5A5"}`,
//                                 display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px",
//                                 color: isSuccess ? "#059669" : "#DC2626"
//                             }}>
//                                 <span style={{ width: 28, height: 28 }}>{isSuccess ? Icons.CheckCircle : Icons.Alert}</span>
//                             </div>
//                             <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Transaction {paymentResult.status}</h3>
//                             <p style={{ fontSize: 14, color: "#6B7280", marginBottom: 24 }}>{paymentResult.message}</p>
//                             <PrimaryButton variant={isSuccess ? "green" : "red"} onClick={() => { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); }}>
//                                 {isSuccess ? "Done" : "Try Again"}
//                             </PrimaryButton>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Fastag;

import React, { useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";

// ─── Icons ───────────────────────────────────────────────────────
const Icons = {
    FASTAG: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="7" width="20" height="10" rx="2" ry="2" />
            <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
            <line x1="12" y1="12" x2="12" y2="12.01" strokeWidth="3" />
            <path d="M8 12h.01M16 12h.01" strokeWidth="2.5" />
        </svg>
    ),
    Search: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
    ),
    Check: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    Lock: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
    ),
    ArrowLeft: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
        </svg>
    ),
    ChevronRight: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
        </svg>
    ),
    Receipt: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" />
            <line x1="8" y1="8" x2="16" y2="8" />
            <line x1="8" y1="12" x2="16" y2="12" />
            <line x1="8" y1="16" x2="12" y2="16" />
        </svg>
    ),
    CheckCircle: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Alert: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
    ),
};

// ─── Config ───────────────────────────────────────────────────────
const FASTAG_CFG = {
    label: "FASTag",
    accent: "#EA580C",
    light: "#FFF7ED",
    border: "#FED7AA",
    dark: "#9A3412",
};

// ─── Helpers ──────────────────────────────────────────────────────
const isFailureResponse = (response) => {
    if (!response) return true;
    const res = response?.data ?? response;
    if (res?.error_code) return true;
    if (Number(res?.status) === 202) return true;
    if (typeof res?.status === "string" &&
        ["FAILED", "FAILURE", "ERROR"].includes(res.status.toUpperCase())) return true;
    return false;
};

const getResponseMessage = (response) => {
    const res = response?.data ?? response;
    return res?.message || res?.customerSummary || res?.error || "Transaction completed";
};

// ─── Sub-components ───────────────────────────────────────────────
const Field = ({ label, type = "text", value, onChange, placeholder, maxLength, error, hint }) => {
    const [focused, setFocused] = useState(false);
    return (
        <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
                {label}
            </label>
            <input
                type={type} value={value} onChange={onChange}
                placeholder={placeholder} maxLength={maxLength}
                onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
                style={{
                    display: "block", width: "100%", height: 44, borderRadius: 10,
                    border: `1.5px solid ${error ? "#EF4444" : focused ? "#1D4ED8" : "#D1D5DB"}`,
                    padding: "0 14px", fontSize: 14, color: "#111827",
                    background: "#fff", outline: "none", fontFamily: "inherit",
                    boxShadow: focused ? "0 0 0 3px rgba(29,78,216,0.1)" : "none",
                    transition: "border-color 0.2s, box-shadow 0.2s", boxSizing: "border-box",
                }}
            />
            {error && <p style={{ marginTop: 5, fontSize: 12, color: "#DC2626" }}>⚠ {error}</p>}
            {hint && !error && <p style={{ marginTop: 5, fontSize: 12, color: "#9CA3AF" }}>{hint}</p>}
        </div>
    );
};

const PrimaryButton = ({ onClick, disabled, loading, children, variant = "navy" }) => {
    const [hovered, setHovered] = useState(false);
    const bgMap = {
        navy: { base: "#1E3A5F", hover: "#15294A", disabled: "#E5E7EB" },
        green: { base: "#059669", hover: "#047857", disabled: "#E5E7EB" },
        red: { base: "#DC2626", hover: "#B91C1C", disabled: "#E5E7EB" },
    };
    const colors = bgMap[variant];
    const bg = disabled || loading ? colors.disabled : hovered ? colors.hover : colors.base;
    return (
        <button
            onClick={onClick} disabled={disabled || loading}
            onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
            style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                width: "100%", height: 48, borderRadius: 12, border: "none",
                background: bg, color: disabled || loading ? "#9CA3AF" : "#fff",
                fontWeight: 700, fontSize: 14, letterSpacing: 0.2,
                cursor: disabled || loading ? "not-allowed" : "pointer",
                fontFamily: "inherit", transition: "background 0.2s",
                boxShadow: disabled || loading ? "none" : "0 1px 3px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1)",
            }}
        >
            {loading ? (
                <>
                    <span style={{ width: 16, height: 16, border: "2px solid #D1D5DB", borderTopColor: "transparent", borderRadius: "50%", display: "inline-block", animation: "ft-spin 0.7s linear infinite" }} />
                    Processing…
                </>
            ) : children}
        </button>
    );
};

const SectionLabel = ({ children }) => (
    <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: "uppercase", color: "#9CA3AF", marginBottom: 14 }}>
        {children}
    </p>
);

const Card = ({ children, style = {} }) => (
    <div style={{
        background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04)",
        padding: 20, ...style,
    }}>
        {children}
    </div>
);

// ─── Main Component ───────────────────────────────────────────────
const Fastag = ({ onBack }) => {
    const mid = useSelector((state) => state.auth.employeeDetails?.username) || "mer2347_7867";
    const merchantAccountNo = useSelector((state) => state.auth.employeeDetails?.merchant_account_no) || "ACC123456";

    const { callApi: fetchBillApi } = useApi("/recharge/fastag-info", "POST");
    const { callApi: payBillApi } = useApi("/recharge/transaction/fastag", "POST");

    const [operators, setOperators] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [isFetchingBill, setIsFetchingBill] = useState(false);
    
    // Form Inputs
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [mpin, setMpin] = useState("");
    const [manualAmount, setManualAmount] = useState("");

    // Field Error Triggers
    const [formErrors, setFormErrors] = useState({});
    
    // Server Response States
    const [billDetails, setBillDetails] = useState(null);
    const [isPaying, setIsPaying] = useState(false);
    const [showResponsePopup, setShowResponsePopup] = useState(false);
    const [paymentResult, setPaymentResult] = useState(null);

    const FASTAG_OPERATORS = [
        { service_id: 195, service_name: "Indian Highways Management Company Ltd-Indusind FASTag" },
        { service_id: 196, service_name: "IndusInd Bank" },
        { service_id: 197, service_name: "Bank Of Baroda" },
        { service_id: 198, service_name: "ICICI Bank" },
        { service_id: 199, service_name: "HDFC Bank" },
        { service_id: 200, service_name: "Airtel Payments Bank NETC FASTag" },
        { service_id: 201, service_name: "IDFC FIRST Bank - FasTag" },
        { service_id: 202, service_name: "Axis Bank" },
        { service_id: 203, service_name: "Kotak Mahindra Bank" },
        { service_id: 204, service_name: "Equitas FASTag Recharge" },
        { service_id: 205, service_name: "Paul Merchants" },
        { service_id: 206, service_name: "Jammu and Kashmir Bank Fastag" },
        { service_id: 207, service_name: "Federal Bank - FASTag" },
        { service_id: 208, service_name: "IDBI Bank FASTag" },
        { service_id: 209, service_name: "UCO Bank FASTag" },
        { service_id: 210, service_name: "Transaction Analyst FASTag" },
        { service_id: 211, service_name: "IOB FASTag" },
        { service_id: 212, service_name: "State Bank of India FASTag" },
        { service_id: 213, service_name: "Transcorp International Limited" },
        { service_id: 214, service_name: "Karnataka Bank Fastag" },
        { service_id: 215, service_name: "Bank of Maharashtra FASTag" },
        { service_id: 216, service_name: "South Indian Bank Fastag" },
        { service_id: 217, service_name: "Saraswat Bank - FASTag" },
        { service_id: 218, service_name: "Indian Bank Fastag" },
        { service_id: 219, service_name: "Livquik Technology India Private Limited" },
        { service_id: 220, service_name: "Union Bank of India FASTag" },
        { service_id: 221, service_name: "Canara Bank Fastag" },
        { service_id: 222, service_name: "AU Bank Fastag" },
        { service_id: 223, service_name: "Bandhan Bank Fastag" },
        { service_id: 224, service_name: "Bajaj Finance Limited Fastag" },
        { service_id: 225, service_name: "Yes Bank FASTag" }
    ];

    const filteredOperators = operators.filter((op) =>
        op.service_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const step = !selectedOperator ? 0 : !billDetails ? 1 : 2;

    React.useEffect(() => {
        setOperators(FASTAG_OPERATORS);
    }, []);

    const validateForm = () => {
        let errors = {};
        if (!vehicleNumber.trim()) {
            errors.vehicleNumber = "Vehicle number is required";
        } else if (!/^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/i.test(vehicleNumber.replace(/\s+/g, ""))) {
            errors.vehicleNumber = "Invalid format (e.g. MH12AB1234)";
        }

        if (!mobileNumber.trim()) {
            errors.mobileNumber = "Mobile number is required";
        } else if (!/^\d{10}$/.test(mobileNumber)) {
            errors.mobileNumber = "Must be a valid 10-digit number";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFetchBill = async () => {
        if (!selectedOperator) return alert("Select an operator bank");
        if (!validateForm()) return;

        setIsFetchingBill(true);
        try {
            const response = await fetchBillApi({
                vehicleNumber: vehicleNumber.toUpperCase().replace(/\s+/g, ""),
                operator: selectedOperator.service_id.toString(),
                addParams: {}
            });

            if (response && (Number(response.status) === 1 || response.status === "SUCCESS")) {
                const nestedData = response.rdata?.[0] || {};
                setBillDetails({
                    customerName: nestedData.CustomerName || "Customer Name",
                    amount: nestedData.Billamount || "0.00",
                    billDate: nestedData.Billdate || "",
                    dueDate: nestedData.Duedate || response.dueDate || "",
                    billValidationId: response.billValidationId || ""
                });
                // Seed input dynamically from fetched response
                // setManualAmount(nestedData.Billamount || "0.00");
            } else {
                alert(response?.message || "Failed to fetch FasTag details");
            }
        } catch (err) {
            console.error(err);
            alert(err?.response?.data?.message || "Something went wrong fetching outstanding balance.");
        } finally {
            setIsFetchingBill(false);
        }
    };

    // const handlePayBill = async () => {
    //     if (!manualAmount || Number(manualAmount) <= 0) return alert("Please enter a valid amount to pay");
    //     if (!mpin) return alert("Enter your MPIN");

    //     const finalAmount = Number(manualAmount);

    //     setIsPaying(true);
    //     try {
    //         const response = await payBillApi({
    //             optr: selectedOperator.service_id.toString(),
    //             type: "FASTAG",
    //             vehicleNumber: vehicleNumber.toUpperCase().replace(/\s+/g, ""),
    //             bill_amount: finalAmount,
    //             mobile: mobileNumber,
    //             consumerName: billDetails?.customerName || "",
    //             dueDate: billDetails?.dueDate || "",
    //             billValidationId: billDetails?.billValidationId || "",
    //             mid: mid,
    //             txn_amount: finalAmount,
    //             net_amount: finalAmount,
    //             merchant_account_no: merchantAccountNo,
    //             add_params: {},
    //             mpin: mpin
    //         });

    //         const failed = isFailureResponse(response);
    //         setPaymentResult({
    //             status: failed ? "FAILED" : response?.status || "SUCCESS",
    //             message: getResponseMessage(response),
    //         });
    //         setShowResponsePopup(true);
    //     } catch (err) {
    //         console.error(err);
    //         setPaymentResult({
    //             status: "FAILED",
    //             message: err?.response?.data?.message || err.message || "Payment processing failed.",
    //         });
    //         setShowResponsePopup(true);
    //     } finally {
    //         setIsPaying(false);
    //     }
    // };

    const handlePayBill = async () => {
    // 💡 Added minimum validation constraint check for ₹100
    if (!manualAmount || Number(manualAmount) < 100) {
        return alert("Minimum recharge amount must be ₹100 or above");
    }
    if (!mpin) return alert("Enter your MPIN");

    const finalAmount = Number(manualAmount);

    setIsPaying(true);
    try {
        const response = await payBillApi({
            optr: selectedOperator.service_id.toString(),
            type: "FASTAG",
            vehicleNumber: vehicleNumber.toUpperCase().replace(/\s+/g, ""),
            bill_amount: billDetails.amount, // Original bill amount from fetched details
            mobile: mobileNumber,
            consumerName: billDetails?.customerName || "",
            dueDate: billDetails?.dueDate || "",
            billValidationId: billDetails?.billValidationId || "",
            mid: mid,
            txn_amount: finalAmount,
            net_amount: finalAmount,
            merchant_account_no: merchantAccountNo,
            add_params: {},
            mpin: mpin
        });

        const failed = isFailureResponse(response);
        setPaymentResult({
            status: failed ? "FAILED" : response?.status || "SUCCESS",
            message: getResponseMessage(response),
        });
        setShowResponsePopup(true);
    } catch (err) {
        console.error(err);
        setPaymentResult({
            status: "FAILED",
            message: err?.response?.data?.message || err.message || "Payment processing failed.",
        });
        setShowResponsePopup(true);
    } finally {
        setIsPaying(false);
    }
  };

    const fullReset = () => {
        setPaymentResult(null);
        setSelectedOperator(null);
        setBillDetails(null);
        setSearchTerm("");
        setMpin("");
        setVehicleNumber("");
        setMobileNumber("");
        setManualAmount("");
        setFormErrors({});
        setShowResponsePopup(false);
    };

    const isSuccess = paymentResult?.status === "SUCCESS";

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        .ft-page {
          min-height: 100vh; background: #F1F5F9;
          font-family: 'DM Sans', sans-serif;
          padding: 28px 16px 80px; -webkit-font-smoothing: antialiased;
        }
        input, button { font-family: 'DM Sans', sans-serif; }
        input::placeholder { color: #9CA3AF; font-size: 13px; }
        .ft-operator-row {
          display: flex; align-items: center; justify-content: space-between;
          padding: 11px 14px; cursor: pointer; font-size: 14px; color: #374151;
          border-bottom: 1px solid #F3F4F6; transition: background 0.15s;
        }
        .ft-operator-row:hover { background: #F8FAFF; color: #1D4ED8; }
        .ft-operator-row:last-child { border-bottom: none; }
        .ft-bill-row {
          display: flex; justify-content: space-between; align-items: center;
          padding: 9px 0; border-bottom: 1px solid #F3F4F6; font-size: 13.5px;
        }
        .ft-bill-row:last-child { border-bottom: none; }
        .ft-tag {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 3px 10px; border-radius: 6px; font-size: 11.5px; font-weight: 600;
        }
        .ft-step-dot {
          width: 28px; height: 28px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 700; transition: all 0.3s ease; flex-shrink: 0;
        }
        @keyframes ft-spin { to { transform: rotate(360deg); } }
        @keyframes ft-fade-up {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes ft-slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0); opacity: 1; }
        }
        .ft-fade-up { animation: ft-fade-up 0.28s ease forwards; }
        @media (max-width: 480px) {
          .ft-page { padding: 20px 12px 60px; }
        }
      `}</style>

            <div className="ft-page">
                <div style={{ maxWidth: 480, margin: "0 auto" }}>

                    {/* ── Header ── */}
                    <div style={{ marginBottom: 24 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            {/* <button
                                onClick={onBack}
                                style={{
                                    width: 38, height: 38, borderRadius: 10, border: "1.5px solid #E5E7EB",
                                    background: "#fff", cursor: "pointer", display: "flex",
                                    alignItems: "center", justifyContent: "center", color: "#374151",
                                    flexShrink: 0, transition: "all 0.15s",
                                }}
                            >
                                <span style={{ width: 16, height: 16 }}>{Icons.ArrowLeft}</span>
                            </button> */}

                            <button
    onClick={() => {
        if (billDetails) {
            // Step 2 -> Step 1 (Payment screen to Vehicle inputs)
            setBillDetails(null);
            setMpin("");
        } else if (selectedOperator) {
            // Step 1 -> Step 0 (Vehicle inputs to Bank search)
            setSelectedOperator(null);
            setSearchTerm("");
            setFormErrors({});
        } else {
            // Step 0 -> Go back completely to where the user came from
            if (typeof onBack === "function") {
                onBack();
            } else {
                // Robust fallback: Uses native browser history to step back 1 page
                window.history.back();
            }
        }
    }}
    style={{
        width: 38,
        height: 38,
        borderRadius: 10,
        border: "1.5px solid #E5E7EB",
        background: "#fff",
        cursor: "pointer",
        display: "inline-flex", // Switched from flex to inline-flex to respect inline layout flows
        alignItems: "center",
        justifyContent: "center",
        color: "#374151",
        flexShrink: 0,
        transition: "all 0.15s",
        position: "relative",
        zIndex: 1, // Dropped to 1 so it stays behind your fixed position NavBar layers (which usually sit at 10 or 50+)
    }}
>
    <span style={{ width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {Icons.ArrowLeft}
    </span>
</button>
                            <div>
                                <p style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 500, letterSpacing: 0.3 }}>Bill Payment</p>
                                <h2 style={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>FASTag Recharge</h2>
                            </div>
                        </div>
                    </div>

                    {/* ── Step Indicator ── */}
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 28 }}>
                        {["Operator", "Details", "Pay"].map((label, i) => {
                            const done = step > i;
                            const active = step === i;
                            return (
                                <React.Fragment key={label}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
                                        <div className="ft-step-dot" style={{
                                            background: done ? "#1E3A5F" : active ? "#FFF7ED" : "#F1F5F9",
                                            border: `2px solid ${done || active ? "#EA580C" : "#D1D5DB"}`,
                                            color: done ? "#fff" : active ? "#EA580C" : "#9CA3AF",
                                        }}>
                                            {done ? <span style={{ width: 12, height: 12 }}>{Icons.Check}</span> : i + 1}
                                        </div>
                                        <span style={{
                                            fontSize: 10, fontWeight: 600, whiteSpace: "nowrap", letterSpacing: 0.2,
                                            color: active ? "#EA580C" : done ? "#6B7280" : "#9CA3AF",
                                        }}>
                                            {label}
                                        </span>
                                    </div>
                                    {i < 2 && (
                                        <div style={{
                                            flex: 1, height: 2, margin: "0 4px", marginBottom: 16,
                                            background: step > i ? "#EA580C" : "#E5E7EB",
                                            transition: "background 0.3s",
                                        }} />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>

                    <div className="ft-fade-up">

                        {/* ── Operator Dropdown Base Page ── */}
                        {!selectedOperator && (
                            <Card style={{ marginBottom: 14 }}>
                                <SectionLabel>Select Issuer Bank</SectionLabel>
                                <div style={{ position: "relative" }}>
                                    <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#9CA3AF", pointerEvents: "none" }}>
                                        {Icons.Search}
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search FasTag issuing bank..."
                                        value={searchTerm}
                                        onChange={(e) => { setSearchTerm(e.target.value); setShowDropdown(true); }}
                                        onFocus={() => setShowDropdown(true)}
                                        style={{ width: "100%", height: 44, borderRadius: 10, border: "1.5px solid #D1D5DB", paddingLeft: 38, paddingRight: 14, fontSize: 14, color: "#111827", outline: "none" }}
                                    />
                                    {showDropdown && filteredOperators.length > 0 && (
                                        <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 50, background: "#fff", borderRadius: 12, border: "1.5px solid #E5E7EB", boxShadow: "0 8px 30px rgba(0,0,0,0.1)", maxHeight: 220, overflowY: "auto" }}>
                                            {filteredOperators.map((op) => (
                                                <div
                                                    key={op.service_id}
                                                    className="ft-operator-row"
                                                    onClick={() => { 
                                                        setSelectedOperator(op); 
                                                        setSearchTerm(op.service_name); 
                                                        setShowDropdown(false); 
                                                    }}
                                                >
                                                    <div>
                                                        <span style={{ fontWeight: 600, color: "#EA580C", marginRight: 8, fontSize: 12 }}>[{op.service_id}]</span>
                                                        <span>{op.service_name}</span>
                                                    </div>
                                                    <span style={{ width: 14, height: 14, color: "#D1D5DB" }}>{Icons.ChevronRight}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Card>
                        )}

                        {/* ── Selected Operator Banner Pill ── */}
                        {selectedOperator && !billDetails && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#FFF7ED", border: "1.5px solid #FED7AA", borderRadius: 12, padding: "10px 14px", marginBottom: 14 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <div style={{ width: 34, height: 34, borderRadius: 8, background: FASTAG_CFG.light, color: FASTAG_CFG.accent, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <span style={{ width: 16, height: 16 }}>{Icons.FASTAG}</span>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 11, color: "#6B7280", marginBottom: 1 }}>Selected Bank Code: {selectedOperator.service_id}</p>
                                        <p style={{ fontSize: 14, fontWeight: 600, color: "#9A3412" }}>{selectedOperator.service_name}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => { setSelectedOperator(null); setBillDetails(null); }}
                                    style={{ fontSize: 12, fontWeight: 600, color: "#EA580C", background: "none", border: "none", cursor: "pointer" }}
                                >
                                    Change
                                </button>
                            </div>
                        )}

                        {/* ── Inputs Page ── */}
                        {selectedOperator && !billDetails && (
                            <Card style={{ marginBottom: 14 }}>
                                <SectionLabel>Vehicle Identification</SectionLabel>
                                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                                    <Field
                                        label="Vehicle Number"
                                        type="text"
                                        value={vehicleNumber}
                                        onChange={(e) => setVehicleNumber(e.target.value.toUpperCase())}
                                        placeholder="e.g. MH12AB1234"
                                        error={formErrors.vehicleNumber}
                                    />
                                    <Field
                                        label="Registered Mobile Number"
                                        type="tel"
                                        maxLength={10}
                                        value={mobileNumber}
                                        onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ""))}
                                        placeholder="Enter 10-digit mobile number"
                                        error={formErrors.mobileNumber}
                                    />
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <PrimaryButton onClick={handleFetchBill} loading={isFetchingBill}>
                                        <span style={{ width: 16, height: 16 }}>{Icons.Receipt}</span>
                                        Fetch Outstanding Balance
                                    </PrimaryButton>
                                </div>
                            </Card>
                        )}

                        {/* ── Bill Info & Payment Screen ── */}
                        {billDetails && (
                            <div>
                                <Card style={{ marginBottom: 14, padding: 0, overflow: "hidden" }}>
                                    {/* <div style={{ background: "linear-gradient(135deg, #431407 0%, #9A3412 100%)", padding: "20px 20px 22px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                            <div>
                                                <p style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", letterSpacing: 0.8, marginBottom: 6, textTransform: "uppercase" }}>Outstanding Balance</p>
                                                <p style={{ fontSize: 32, fontWeight: 700, color: "#fff", fontFamily: "'DM Mono', monospace" }}>
                                                    ₹{billDetails.amount}
                                                </p>
                                            </div>
                                            <div style={{ textAlign: "right" }}>
                                                <p style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", marginBottom: 4 }}>Due Date</p>
                                                <p style={{ fontSize: 14, fontWeight: 600, color: "#FCD34D" }}>{billDetails.dueDate || "N/A"}</p>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div style={{ padding: "16px 20px" }}>
                                        <SectionLabel>Statement Summary</SectionLabel>
                                        {[
                                            { label: "Customer Name", value: billDetails.customerName },
                                            { label: "Vehicle Number", value: vehicleNumber.toUpperCase() },
                                            // { label: "Validation ID", value: billDetails.billValidationId },
                                            { label: "Bill Amount", value: billDetails.amount||"N/A"},
                                            { label: "Due Date", value: billDetails.dueDate || "N/A" },

                                            { label: "Bill Date", value: billDetails.billDate || "N/A" },
                                            { label: "Issuer Bank", value: selectedOperator.service_name },
                                        ].map(({ label, value }) => (
                                            <div key={label} className="ft-bill-row">
                                                <span style={{ color: "#6B7280" }}>{label}</span>
                                                <span style={{ fontWeight: 500, color: "#111827" }}>{value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </Card>

                                <Card>
                                    <SectionLabel>Complete Transaction</SectionLabel>
                                    {manualAmount && 
                                    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#FFF7ED", border: "1px solid #FED7AA", borderRadius: 10, padding: "11px 14px", marginBottom: 16 }}>
                                        <span style={{ width: 16, height: 16, color: "#EA580C", marginTop: 1, flexShrink: 0 }}>{Icons.Alert}</span>
                                        <p style={{ fontSize: 12.5, color: "#9A3412", lineHeight: 1.55 }}>
                                            You are authorizing a payment for {" "}
                                            <strong style={{ fontFamily: "'DM Mono', monospace" }}>₹{manualAmount || "—"}</strong>.
                                        </p>
                                    </div>
                                    }

                                    {/* Manual Amount Input */}
                                    {/* <div style={{ marginBottom: 16 }}>
                                        <Field
                                            label="Recharge Amount"
                                            type="number"
                                            value={manualAmount}
                                            onChange={(e) => setManualAmount(e.target.value)}
                                            placeholder="Enter amount"
                                            hint={`Fetched Bill Amount: ₹${billDetails.amount} · Bill Date: ${billDetails.billDate || 'N/A'} · Due Date: ${billDetails.dueDate || 'N/A'}`}
                                        />
                                    </div> */}

                                    {/* Manual Amount Input */}
  <div style={{ marginBottom: 16 }}>
      <Field
          label="Recharge Amount"
          type="number"
          value={manualAmount}
          onChange={(e) => setManualAmount(e.target.value)}
          placeholder="Enter amount"
          // 💡 Highlights the form input box red dynamically if value is below 100
          error={manualAmount && Number(manualAmount) < 100 ? "Amount must be at least ₹100" : ""}
          
      />
  </div>    

                                    <Field
                                        label="6-Digit Security MPIN" type="password" maxLength={6}
                                        value={mpin} onChange={(e) => setMpin(e.target.value.replace(/\D/g, ""))}
                                        placeholder="● ● ● ● ● ●"
                                    />
                                    <div style={{ marginTop: 16 }}>
                                        {/* <PrimaryButton onClick={handlePayBill} loading={isPaying}>
                                            <span style={{ width: 16, height: 16 }}>{Icons.Lock}</span>
                                            Pay ₹{manualAmount || "—"} Now
                                        </PrimaryButton> */}
                                        <PrimaryButton 
    onClick={handlePayBill} 
    loading={isPaying}
    disabled={!manualAmount || Number(manualAmount) < 100 || !mpin || mpin.length < 6}
>
    <span style={{ width: 16, height: 16 }}>{Icons.Lock}</span>
    Pay ₹{manualAmount || "—"} Now
</PrimaryButton>
                                    </div>
                                </Card>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ── Transaction Status Modal ── */}
            {showResponsePopup && paymentResult && (
                // <div
                //     style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", display: "flex", alignItems: "flex-end", justifyContent: "center" }}
                //     onClick={{ if (e.target === e.currentTarget) { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); } }}
                // >
//                 <div
//     style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}
//     onClick={(e) => { if (e.target === e.currentTarget) { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); } }}
// >
//                     <div style={{ width: "100%", maxWidth: 480, background: "#fff", borderRadius: "20px", paddingBottom: 40, }} onClick={e => e.stopPropagation()}>
//                         <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 0" }}>
//                             <div style={{ width: 32, height: 4, borderRadius: 2, background: "#E5E7EB" }} />
//                         </div>
//                         <div style={{ padding: "24px 28px 0", textAlign: "center" }}>
//                             <div style={{
//                                 width: 60, height: 60, borderRadius: "50%",
//                                 background: isSuccess ? "#ECFDF5" : "#FEF2F2",
//                                 border: `2px solid ${isSuccess ? "#6EE7B7" : "#FCA5A5"}`,
//                                 display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px",
//                                 color: isSuccess ? "#059669" : "#DC2626"
//                             }}>
//                                 <span style={{ width: 28, height: 28 }}>{isSuccess ? Icons.CheckCircle : Icons.Alert}</span>
//                             </div>
//                             <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Transaction {paymentResult.status}</h3>
//                             <p style={{ fontSize: 14, color: "#6B7280", marginBottom: 24 }}>{paymentResult.message}</p>
                            
//                             <div style={{
//                                 display: "flex", justifyContent: "space-between",
//                                 background: "#F8FAFC", borderRadius: 12, padding: "14px 18px",
//                                 marginBottom: 20, border: "1px solid #E5E7EB",
//                             }}>
//                                 <div style={{ textAlign: "left" }}>
//                                     <p style={{ fontSize: 11, color: "#9CA3AF", marginBottom: 2 }}>Service</p>
//                                     <p style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>FASTag</p>
//                                 </div>
//                                 <div style={{ textAlign: "right" }}>
//                                     <p style={{ fontSize: 11, color: "#9CA3AF", marginBottom: 2 }}>Recharged Amount</p>
//                                     <p style={{ fontSize: 14, fontWeight: 700, color: isSuccess ? "#059669" : "#DC2626", fontFamily: "'DM Mono', monospace" }}>
//                                         ₹{manualAmount}
//                                     </p>
//                                 </div>
//                             </div>

//                             <PrimaryButton variant={isSuccess ? "green" : "red"} onClick={() => { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); }}>
//                                 {isSuccess ? "Done" : "Try Again"}
//                             </PrimaryButton>
//                         </div>
//                     </div>
//                 </div>

<div
    className="fixed inset-0 z-[999] bg-slate-900/50 backdrop-blur-[4px] flex items-center justify-center p-4"
    onClick={(e) => { if (e.target === e.currentTarget) { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); } }}
>
    {/* 💡 Applied w-[80%] for mobile, sm:w-full for normal scales up to the max-width */}
    <div 
        className="w-[90%] sm:w-full max-w-[480px] bg-white rounded-2xl pb-10 shadow-2xl mx-auto" 
        onClick={e => e.stopPropagation()}
    >
        <div className="flex justify-center pt-3">
            <div className="w-8 h-1 rounded bg-gray-200" />
        </div>
        <div className="pt-6 px-7 text-center">
            <div className={`w-[60px] h-[60px] rounded-full flex items-center justify-center mx-auto mb-4.5 border-2
                ${isSuccess ? "bg-emerald-50 border-emerald-300 text-emerald-600" : "bg-red-50 border-red-300 text-red-600"}`}>
                <span className="w-7 h-7">{isSuccess ? Icons.CheckCircle : Icons.Alert}</span>
            </div>
            <h3 className="text-xl font-bold mb-2">Transaction {paymentResult.status}</h3>
            <p className="text-sm text-gray-500 mb-6 leading-relaxed">{paymentResult.message}</p>
            
            <div className="flex justify-between bg-slate-50 border border-gray-200 rounded-xl p-[14px_18px] mb-5">
                <div className="text-left">
                    <p className="text-[11px] text-gray-400 mb-0.5">Service</p>
                    <p className="text-sm font-semibold text-gray-900">FASTag</p>
                </div>
                <div className="text-right">
                    <p className="text-[11px] text-gray-400 mb-0.5">Recharged Amount</p>
                    <p className={`text-sm font-bold font-mono ${isSuccess ? "text-emerald-600" : "text-red-600"}`}>
                        ₹{manualAmount}
                    </p>
                </div>
            </div>

            <PrimaryButton variant={isSuccess ? "green" : "red"} onClick={() => { setShowResponsePopup(false); isSuccess ? onBack() : fullReset(); }}>
                {isSuccess ? "Done" : "Try Again"}
            </PrimaryButton>
        </div>
    </div>
</div>
            )}
        </>
    );
};

export default Fastag;